import * as types from "./types";

export const updateBranchesList = (payload) => (dispatch) =>
    dispatch({ type: types.UPDATE_BRANCHES_LIST, payload });

export const setBranchesList = (payload) => (dispatch) =>
    dispatch({ type: types.SET_BRANCHES_LIST, payload });
